import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {CookieModule} from 'ngx-cookie';
import {UserService} from './shared/services/user.service';
import {SessionService} from './shared/services/session.service';
import {CommonDataService} from './shared/services/common-data.service';
import {SystemService} from './shared/services/system.service';
import {httpExtensionService} from './shared/services/httpextension.service';
import {AuthorizationGuard} from './shared/guards/authorization.guard';
import {routing} from './app.routing';
import {AppComponent} from './app.component';
import {SidebarComponent} from './shared/sidebar/sidebar.component';
import {HeaderComponent} from './shared/header/header.component';
import {ConfirmationService, MessagesModule, ConfirmDialogModule} from 'primeng/primeng';
import {SettingsService} from './shared/services/settings.service';
import {OrdersService} from './shared/services/orders.service';
import {MembersService} from './shared/services/members.service';
import {EmployeesService} from './shared/services/employees.service';
import {SortablejsModule} from 'angular-sortablejs';
import {HomeComponent} from './home/home.component';
import {ConfigService} from './config/config.service';
import {CampaignModule} from './campaign/campaign.module';
import {CampaignService} from "./campaign/campaign.service";

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        SidebarComponent,
        HeaderComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        ReactiveFormsModule,
        routing,
        CookieModule.forRoot(),
        MessagesModule,
        ConfirmDialogModule,
        SortablejsModule,
        CampaignModule
    ],
    providers: [
        UserService,
        ConfigService,
        SessionService,
        SettingsService,
        CommonDataService,
        SystemService,
        AuthorizationGuard,
        httpExtensionService,
        OrdersService,
        MembersService,
        ConfirmationService,
        EmployeesService,
        CampaignService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts